import { Box, styled } from '@mui/material';

export const FooterStyled = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.colors.footerBackground,
  right: 0,
  bottom: 0,
  left: 0,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  padding: '16px 0 24px',
  alignItems: 'center',

  [theme.breakpoints.up('sm')]: {
    padding: '60px 40px 24px',
  },
  [theme.breakpoints.up('lg')]: {
    alignItems: 'flex-start',
    padding: '60px 40px 48px',
  },
}));
